import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  CircularProgress,
  Button,
  useTheme,
} from "@mui/material";
import { Checkbox } from "@mui/material";
const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
const FactoryIssueCard = ({ item, onDetailsChange, onSelectChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const theme = useTheme();
  const [localDetails, setLocalDetails] = useState(item.details);
  const isImageFile = (fileName) => {
    if (!fileName) return false;
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
  };

  const [imagePage, setImagePage] = useState(0);

  const [imageIndex, setImageIndex] = useState(0);

  const currentImage = item.imageData?.[imageIndex] || null;
  useEffect(() => {
    const detailText =
      item.imageData?.length > 0
        ? item.imageData
            .map((img) => `Pos ${img.posNo || "-"} - ${img.details || "-"}`)
            .join("\n")
        : "";

    setLocalDetails(detailText);
  }, [item]);
  return (
    <Paper
      elevation={2}
      sx={{
        height: { xs: "auto", md: "100%" },
        minHeight: { xs: 400, md: "auto" },
        display: "flex",
        flexDirection: "column",
        border: "1px solid #ccc",
      }}
    >
      <Box
        sx={{
          p: 1.5,
          borderBottom: "1px solid #ddd",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography fontWeight="bold" noWrap>
          {item.reason}
        </Typography>

        <Checkbox
          checked={item.selected}
          onChange={(e) => onSelectChange(item.id, e.target.checked)}
          color="secondary"
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          overflow: { xs: "visible", md: "hidden" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "35%" },
            borderRight: { xs: "none", md: "1px solid #000" },
            borderBottom: { xs: "1px solid #000", md: "none" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            {[
              { label: "Country", value: item.country },
              { label: "Order Placed Date", value: item.createdDate },

              ...(item.orderDate
                ? [{ label: "Org Order Loading Date", value: item.orderDate }]
                : []),

              { label: "AB Number", value: item.abNumber },
              { label: "Pos. Number", value: item.posNo },
              { label: "Article Code", value: item.articleCode },
            ].map((row, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <Box
                  sx={{
                    width: { xs: 130, sm: 170 },
                    p: 0.8,
                    fontWeight: "bold",
                    whiteSpace: { xs: "normal", sm: "nowrap" },
                    fontSize: { xs: "0.85rem", sm: "1rem" },
                  }}
                >
                  {row.label}
                </Box>

                <Box
                  sx={{
                    width: 10,
                    p: 0.8,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  :
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    p: 0.8,
                    wordBreak: "break-word",
                  }}
                >
                  {row.value || "-"}
                </Box>
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              flex: 1,
              p: 1,
              overflowY: "auto",
              borderTop: "1px solid #000",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography fontWeight="bold">Details :</Typography>
              {!isEditing && (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => setIsEditing(true)}
                  style={{
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                  }}
                >
                  Edit
                </Button>
              )}
            </Box>

            {!isEditing ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {item.imageData?.length > 0
                  ? item.imageData
                      .map(
                        (img) =>
                          `Pos ${img.posNo || "-"} - ${img.details || "-"}`,
                      )
                      .join("\n")
                  : "-"}
              </Typography>
            ) : (
              <TextField
                fullWidth
                multiline
                minRows={4}
                value={localDetails}
                onChange={(e) => setLocalDetails(e.target.value)}
              />
            )}
          </Box>

          {isEditing && (
            <Box
              sx={{
                p: 1,
                display: "flex",
                gap: 1,
                justifyContent: "flex-end",
              }}
            >
              <Button
                size="small"
                variant="contained"
                //  style={{ backgroundColor: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }}
                color="secondary"
                onClick={() => {
                  const lines = localDetails.split("\n");

                  const updatedImageData = item.imageData.map((img, index) => {
                    const line = lines[index] || "";

                    const parts = line.split(" - ");

                    return {
                      ...img,
                      details:
                        parts.length > 1
                          ? parts.slice(1).join(" - ").trim()
                          : img.details,
                    };
                  });

                  onDetailsChange(item.id, updatedImageData);

                  setIsEditing(false);
                }}
              >
                Save
              </Button>
              <Button
                size="small"
                color="secondary"
                //  style={{ backgroundColor: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }}
                variant="outlined"
                onClick={() => {
                  setLocalDetails(item.details);
                  setIsEditing(false);
                }}
              >
                Cancel
              </Button>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "65%" },
            display: "flex",
            flexDirection: "column",
            p: 1,
            alignItems: "center",
          }}
        >
          {currentImage ? (
            <>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                POS No : {currentImage.posNo || "-"}
              </Typography>

              {currentImage.isImage ? (
                <>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                      width: "100%",
                    }}
                  >
                    <img
                      src={`${url}api/static/downloadPicture?picture=${currentImage.picture}`}
                      alt=""
                      style={{ maxWidth: "100%", maxHeight: "260px", objectFit: "contain" }}
                    />
                  </Box>

                  <Typography sx={{ mt: 1 }}>
                    <b>Article Code :</b> {currentImage.articleCode || "-"}
                  </Typography>
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Typography color="primary" fontWeight="bold">
                      Attachment
                    </Typography>

                    <Button
                      variant="contained"
                      component="a"
                      href={`${url}api/static/downloadPicture?picture=${encodeURIComponent(
                        currentImage.picture,
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open Attachment
                    </Button>

                    <Typography
                      variant="caption"
                      sx={{
                        maxWidth: 250,
                        textAlign: "center",
                        wordBreak: "break-word",
                      }}
                    >
                      {currentImage.picture}
                    </Typography>

                    <Typography>
                      <b>Article Code :</b> {currentImage.articleCode || "-"}
                    </Typography>
                  </Box>
                </>
              )}

              {item.imageData.length > 1 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 1,
                  }}
                >
                  <Button
                    size="small"
                    disabled={imageIndex === 0}
                    onClick={() => setImageIndex((p) => p - 1)}
                  >
                    Prev
                  </Button>

                  <Typography>
                    {imageIndex + 1} / {item.imageData.length}
                  </Typography>

                  <Button
                    size="small"
                    disabled={imageIndex === item.imageData.length - 1}
                    onClick={() => setImageIndex((p) => p + 1)}
                  >
                    Next
                  </Button>
                </Box>
              )}
            </>
          ) : (
            <Typography color="text.secondary">No Image Available</Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default FactoryIssueCard;
